import React from "react";
import HReusableAlertModal from "./HReusableAlertModal";

const HConfirmDialog = ({
  show,
  onClose,
  onConfirm,
  isLoading = false,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "destructive", // 'destructive', 'primary', 'secondary'
}) => {
  return (
    <HReusableAlertModal
      isOpen={show}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      description={message}
      confirmLabel={confirmText}
      cancelLabel={cancelText}
      confirmVariant={confirmVariant}
      isLoading={isLoading}
    />
  );
};

export default HConfirmDialog;
